import Vue from 'vue'
import Vuex from 'vuex'

import search from '@/search'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        navigation: {
            breadcrumbs: [],
            active: ""
        },
        search: {
            filter: {
                
            },
            pagination: {
                numItems: 0,
                currentPage: 1
            },
            resultList: []
        },
        archiveItems: []
    },
    mutations: {
        setBreadcrumb(state, bc) {
            state.navigation.breadcrumbs = bc
        },
        setActivePage(state, page) {
            state.navigation.active = page
        },
        resetSearchFilter(state) {
            state.search.filter = {}
        },
        setSearchFilter(state, filter) {
            state.search.filter = filter
        },
        setSearchResult(state, res) {
            state.search.resultList = res
        },
        setArchiveItems(state, items) {
            state.archiveItems = items
        }
    },
    actions: {
        updateSearch(context, filter) {
            search.applyFilter(filter)
            context.commit('setSearchResult', search.getResults())
        },
        setupItems(context) {
            context.commit('setArchiveItems', search.getIndex())
        }
    },
    getters: {
        getSearchResult: state => state.search.resultList,
        getAllItems: state => state.archiveItems,
        getIndexFromSlug: state => slug => search.getIndexBySlug(slug),
        getItemFromResult: state => index => state.archiveItems[index]
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js